import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "../../../services/generic-http.service";
import { ApiUrlConstant } from "./../../../constants/api-url.constant";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';

@Injectable()
export class DataService {
  baseUrl = environment.gateWayHost;
  editItem: any;
  constructor(
    public generic: GenericHttpService,
    public utils: GenericUtils) { }

  getData(api, config, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${api}`,
      query: params
    };
    const functionToExecute = this.returnFunctionToExecute(config.id);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  returnFunctionToExecute(widgetId) {
    if (widgetId === 27) {
      return this.processPODAvailabilityData;
    }
  }
  processPODAvailabilityData(data: any) {
    if (data.data[0].TransportationPODAvailability.length === 0) return null;
    const value = data.data[0].TransportationPODAvailability[0];
    return [value.hard_copy, value.soft_copy];
  }

  createChart(chartData, options) {
    const chart = this.utils.deepCopyFunction(HSET.chartData);
    chart.series[0].data = chartData[0];
    chart.series[1].data = chartData[1];

    if (options[0].xAxis) {
      if (options[0].xAxis.style) {
        chart.xAxis.labels.style.fontSize = options[0].xAxis.style.fontSize;
      }

      // do nothing for now. This is just a provision for the future
    }

    if (options[0].yAxis) {
      for (let i = 0; i < options[0].yAxis.length; i++) {

        // if (options[0].yAxis[i].min) {
        //   chart.yAxis[i].min = options[0].yAxis[i].min;
        // }
        // if (options[0].yAxis[i].max) {
        //   chart.yAxis[i].max = options[0].yAxis[i].max;
        // }

        if (options[0].yAxis[i].title) {
          const TITLE = options[0].yAxis[i].title;
          if (TITLE.text) {
            chart.yAxis[i].title.text = TITLE.text;
          }
          if (TITLE.style) {
            // do nothing for now. This is just a provision for the future
          }
        }

        if (options[0].yAxis.label) {
          const LABEL = options[0].yAxis[i].title;
          if (LABEL.text) {
            chart.yAxis[i].labels.text = LABEL.text;
          }
          if (LABEL.style) {
            chart.yAxis[i].labels.style.fontSize = LABEL.style.fontSize;
            chart.yAxis[i].labels.style.fontWeight = LABEL.style.fontWeight;
            chart.yAxis[i].labels.style.color = LABEL.style.color;
          }
        }
      }
    }

    if (options[0].legend) {
      if (options[0].legend.style) {
        const STYLE = options[0].legend.style;
        chart.legend.itemStyle.fontSize = STYLE.fontSize;
        chart.legend.itemStyle.fontWeight = STYLE.fontWeight;
        chart.legend.itemStyle.color = STYLE.color;
      }

      if (options[0].legend.colorSet) {
        const COLORSET = options[0].legend.colorSet;
        for (let i = 0; i < COLORSET.length; i++) {
          chart.series[i].color = COLORSET[i];
        }
      }
    }

    if (options[0].series) {
      if (options[0].series.name) {
        const NAMES = options[0].series.name;
        const TOOLTIP = options[0].series.tooltipSuffix ? options[0].series.tooltipSuffix : [];
        for (let i = 0; i < NAMES.length; i++) {
          chart.series[i].name = NAMES[i];
          if (TOOLTIP[i]) {
            chart.series[i].tooltip.valueSuffix = TOOLTIP[i];
          }
        }
      }
    }

    if (options[0].noTarget) {
      chart.series.pop();
      chart.plotOptions.line.dataLabels.enabled = false;
    }

    return chart;
  }
}
